export const getSizeWithUnit = (size)=>{
    if (size >= 1048576) {
        return `${Math.round(size / 1048576)} MB`;
    }
    if (size >= 1024) {
        return `${Math.round(size / 1024)} kB`;
    }
    return `${size} B`;
};
